(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ChartExplorerModel", [], factory);
	else if(typeof exports === 'object')
		exports["ChartExplorerModel"] = factory();
	else
		root["ChartExplorerModel"] = factory();
})(window, function() {
return 